import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "./ContractForm.css";
import Form from "./Form";
import apiClient from '../../services/apiClient';
import Swal from "sweetalert2";
import { getErrorMessage } from "../../services/errorHelper";
import { setTitle } from "../../redux/titleSlice";
import { useNavigate } from "react-router-dom/dist/umd/react-router-dom.development";

export default function ContractForm() {
  const [showCustomURLInput, setShowCustomURLInput] = useState(true);
  const [savedFormData, setSavedFormData] = useState(null);
    const title = useSelector((state) => state.title.title);
    const navigate = useNavigate();
    const childStateRef = useRef();

    const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setTitle('Untitled Contact Form'));
  }, []);

  const handleRadioChange = (event) => {
    setShowCustomURLInput(event.target.value === "custom");
  };

  const [expanded, setExpanded] = useState(false);

  const toggleSidebar = () => {
    setExpanded(!expanded);
  };


    useEffect(() => {
      // Create a <style> tag
      const styleTag = document.createElement("style");
      styleTag.innerHTML = "body { background-color: #f1f4f9 !important; }";
  
      // Append the <style> tag to the head
      document.head.appendChild(styleTag);
  
      // Cleanup: remove the style when the component unmounts
      return () => {
        document.head.removeChild(styleTag);
      };
    }, []);


    useEffect(() => {
      const publishHandler = () => {
        handleSubmit();
      };

      window.addEventListener("publishContactForm", publishHandler);

      return () => {
        window.removeEventListener("publishContactForm", publishHandler);
      };
    }, []);


  const handleSubmit = async () => {
    const questionstate = childStateRef.current.getQuestion();
    const Title_2 = title;
    const placeholder_2 = childStateRef.current.getPlaceholder2();
    if (!title.trim()) {
                          Swal.fire({
                            icon: "error",
                            title: "Error",
                            text: "Form title is required",
                          });
                          return;
                        }
    try {
          const response = await apiClient.post(`/contactForm`,
            {
              user_id: JSON.parse(localStorage.getItem('user')).user.id,
              title: Title_2,
              placeholder: placeholder_2,
              email_to: JSON.parse(localStorage.getItem('user')).user.email,
              questions: questionstate.map((tab) => ({
                type: tab.type,
                showServiceInfo: tab.showServiceInfo,
                ques: tab.ques,
                ques2: tab.ques2,
                placeholder: tab.placeholder,
                placeholder2: tab.placeholder2,
                options: tab.option, // no stringify
                optionadd: tab.optionadd,
              })),
            }
          );

            const slug = response.data.data.slug;
            const title = response.data.data.title;
            const completeUrl = `${window.location.origin}/showContactForm/${slug}`;
            const embedCode = `<iframe src="https://app.eventtrackit.com/showContactForm/${slug}" frameborder="0" width="600" height="400"></iframe>`;


          window.dispatchEvent(
            new CustomEvent("contactFormSaved", {
              detail: { slug, title, completeUrl, embedCode }
            })
          );
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: getErrorMessage(error),
      });
    }
  }

  return (
    <>
      <div className='container-fluid p-lg-0 py-lg-3 p-md-5 p-3'>
        <div className='row g-lg-5 g-md-5 g-3 px-lg-5'>
          {/*begin: Main form area */}
          <div className='col-md-8' style={{margin: "0 auto"}}>
            <div className='form_container'>
              <Form ref={childStateRef} />
            </div>

{/* 
            <button
                        id='submit-btn'
                        type='button'
                        className='px-5 rounded-pill btn btn-primary btn-lg text-uppercase'
                        onClick={handleSubmit}
                        >
                        Save
                      </button> */}



          </div>
          {/*end: Main form area */}
        </div>
      </div>
    </>
  );
}
